import { useScript } from "@sphtech/web2-core/hooks";
import type { LinksFunction } from "react-router";

import { useShouldRenderOutbrain } from "../_hooks/useShouldRenderOutbrain";
import styles from "./Outbrain.css?url";
export const OutbrainLinks: LinksFunction = () => [
  { rel: "stylesheet", href: styles },
];

/**
 * Outbrain
 * @tutorial https://sph.atlassian.net/wiki/spaces/CA/pages/2071167069/Outbrain+integration+for+article+and+amp+article
 */
export default function Outbrain({ src }: { src: string }) {
  const shouldRenderOutbrain = useShouldRenderOutbrain();

  useScript({
    src: "https://widgets.outbrain.com/outbrain.js",
    id: "outbrain-script",
    async: true,
  });

  console.log(shouldRenderOutbrain, "shouldRenderOutbrain");
  if (!shouldRenderOutbrain) {
    return null;
  }

  return <div className="OUTBRAIN" data-src={src} data-widget-id="AR_1" />;
}
